import {json, texture} from "p3";
import GameScene from "../../scenes/GameScene";

export default class QuestTrackerPopup extends PIXI.Container {
    /**
     * @param {string} type
     * @param {Quest} quest
     */
    constructor(type, quest) {
        super();

        this._type = type;
        this._quest = quest;
        this._frame = null;
        this._icon = null;
        this._npcData = null
    }

    init() {
        //this._frame = new PIXI.Sprite(texture("panel_progess_tracker"));
        this._frame = new PIXI.NineSlicePlane(texture("panel_progess_tracker"), 80, 20, 20, 20);
        this._frame.width = 480;
        this.addChild(this._frame);

        //this.pivot.set(this._frame.texture.width * 0.5, this._frame.texture.height * 0.5);
        this.pivot.set(this._frame.width * 0.5, this._frame.texture.height * 0.5);

        this._npcData = json(this._quest.owner);
        const questData = this._npcData.quests[this._quest.id]

        this._icon = new PIXI.Sprite(texture(questData.avatar || this._npcData.character.avatar));
        this._icon.position.set(43, (this._frame.texture.height * 0.5) - 13);
        this._icon.anchor.set(0.5);
        this.addChild(this._icon);

        if (GameScene.active.isMinigameActive) {
            this.y += 130;
        }
    }

    update() {
    }

    /**
     * @return {Promise}
     */
    animateIn() {
        return new Promise((resolve) => {
            this.scale.set(0);
            this.alpha = 1;

            GameScene.active.addTween(gsap.to(this.scale, 0.24, {
                x: 1,
                y: 1,
                ease: Back.easeOut,
                onStart: () => this.visible = true,
                onComplete: resolve
            }));
        });
    }

    /**
     * @return {Promise}
     */
    animateOut() {
        return new Promise((resolve) => {
            const tl = gsap.timeline({ onComplete: resolve });
            GameScene.active.addTween(tl);

            tl.add(gsap.to(this, 0.14, {
                alpha: 0,
                ease: Power2.easeInOut,
                onComplete: () => this.visible = false
            }));
            tl.add(gsap.delayedCall(0.5, () => {}));
        });
    }

    /**
     * @return {string}
     */
    get type() {
        return this._type;
    }

    /**
     * @return {Quest}
     */
    get quest() {
        return this._quest;
    }
}

/**
 * @static
 * @type {string}
 */
QuestTrackerPopup.TYPE_ASSIGN = "assign";

/**
 * @static
 * @type {string}
 */
QuestTrackerPopup.TYPE_PROGRESS = "progress";

/**
 * @static
 * @type {string}
 */
QuestTrackerPopup.TYPE_COMPLETE = "complete";
